// packages/main/app/web/components-v2/PixabayImageBrowser/styles.ts
import { StyleSheet } from 'aphrodite';
import { THEME } from '../Theme/theme';

export const s = StyleSheet.create({
	container: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		overflow: 'hidden',
	},
	searchSection: {
		padding: THEME.spacing.lg,
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	searchLabel: {
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		marginBottom: THEME.spacing.sm,
		display: 'block',
	},
	searchRow: {
		display: 'flex',
		gap: THEME.spacing.md,
		alignItems: 'center',
	},
	searchInput: {
		flex: 1,
	},
	resultsSection: {
		flex: 1,
		overflow: 'auto',
		padding: THEME.spacing.lg,
	},
	imageGrid: {
		display: 'grid',
		gridTemplateColumns: 'repeat(auto-fill, minmax(150px, 1fr))',
		gap: THEME.spacing.md,
	},
	imageCard: {
		position: 'relative',
		aspectRatio: '1',
		borderRadius: THEME.common.borderRadius,
		overflow: 'hidden',
		cursor: 'pointer',
		border: `2px solid ${THEME.colors.border.light}`,
		transition: 'all 0.2s',
		':hover': {
			border: `2px solid ${THEME.colors.primary.main}`,
			transform: 'scale(1.02)',
		},
	},
	imageCardImage: {
		width: '100%',
		height: '100%',
		objectFit: 'cover',
	},
	previewSection: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
	previewImageContainer: {
		flex: 1,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: THEME.spacing.xl,
		backgroundColor: THEME.colors.background.light,
	},
	previewImage: {
		maxWidth: '100%',
		maxHeight: '100%',
		objectFit: 'contain',
		borderRadius: THEME.common.borderRadius,
	},
	previewActions: {
		display: 'flex',
		gap: THEME.spacing.md,
		padding: THEME.spacing.lg,
		borderTop: `1px solid ${THEME.colors.border.light}`,
		justifyContent: 'flex-end',
	},
	loadingContainer: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		padding: THEME.spacing.xl,
		color: THEME.colors.text.light,
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: THEME.spacing.xl,
		color: THEME.colors.text.light,
		textAlign: 'center',
		gap: THEME.spacing.sm,
	},
	emptyStateTitle: {
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
	},
	emptyStateDescription: {
		fontSize: THEME.typography.fontSizes.sm,
	},
	loadMoreTrigger: {
		padding: THEME.spacing.md,
		textAlign: 'center',
	},
	poweredBy: {
		display: 'flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: THEME.spacing.sm,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	poweredByLogo: {
		height: '16px',
		width: 'auto',
	},
});
